module.exports = __webpack_public_path__ + "static/media/0325_IMG_LES_MURS_P21_UNI_CRISTAL_HORIZONTALE.4cf538c8.png";